
/** The one program Elowen runs: the embedded brain. */
export const PROVIDERS = [
  { label: 'Chetty AI' },
];
